// import { Languages, useLanguageStore } from '@/store';
import ServiceAgreementZH from './ServiceAgreementZH';
import ServiceAgreementEN from './ServiceAgreementEN';
import { Languages, useLanguageStore } from '../../hooks';

export function ServiceAgreement() {
  const lang = localStorage.getItem('lang');

  return lang === Languages.zh ? (
    <ServiceAgreementZH />
  ) : (
    <ServiceAgreementEN />
  );
}

export default ServiceAgreement;
